/* eslint-disable jsx-a11y/label-has-for */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import _isEmpty from 'lodash/isEmpty';
import { useStoreFinderContext } from '@/storeFinder/context';
// import gtm stuff
import { pushGtmServiceLocatorSearch } from '@/utils/Controllers/GTM/Operations/ServiceLocator';
import { DEFAULT_DISTANCE } from '@/storeFinder/context/selectors';

const ACTIVE_CLASS = 'dln-inputs--active';
const WRITING_CLASS = 'dln-inputs--writing';

const checkActiveClass = (val, writingState) =>
  _isEmpty(val) && _isEmpty(writingState) ? '' : ACTIVE_CLASS;

const GoogleAutocomplete = ({ googleMapIsLoaded }) => {
  const { t } = useTranslation();
  const [activeClass, setActiveClass] = useState('');
  const [writingClass, setWritingClass] = useState('');
  const [, { setSearch }] = useStoreFinderContext();
  const refWrapAutocomplete = useRef();
  const autocompleteRef = useRef();

  const optionsAutocomplete = {
    types: ['geocode'],
    componentRestrictions: { country: DLG.gigya.country },
  };

  const handlePlaceChanged = () => {
    pushGtmServiceLocatorSearch();
    setSearch({
      currentDistance: DEFAULT_DISTANCE,
      currentLatLng: {
        latitude: autocompleteRef.current.getPlace().geometry.location.lat(),
        longitude: autocompleteRef.current.getPlace().geometry.location.lng(),
      },
      searched: autocompleteRef.current.getPlace().formatted_address,
    });
  };

  useEffect(() => {
    if (!googleMapIsLoaded) {
      return;
    }

    autocompleteRef.current = new google.maps.places.Autocomplete(
      refWrapAutocomplete.current,
      optionsAutocomplete,
    );
    autocompleteRef.current.addListener('place_changed', handlePlaceChanged);
  }, [googleMapIsLoaded]);

  const handleInnerOnFocus = () => {
    setActiveClass(ACTIVE_CLASS);
  };

  const handleInnerOnChange = () => {
    setWritingClass(WRITING_CLASS);
  };

  const handleInnerOnBlur = e => {
    setActiveClass(checkActiveClass(e.target.value, ''));
    setWritingClass('');
  };

  return (
    <div
      className={`dln-inputs dln-inputs--searchBar dln-inputs--googleAutocomplete ${activeClass} ${writingClass}`}
    >
      <input
        className='dln-inputs__input dln-outline'
        id='input-autocomplete-simply'
        type='text'
        onFocus={handleInnerOnFocus}
        onChange={handleInnerOnChange}
        onBlur={handleInnerOnBlur}
        ref={refWrapAutocomplete}
      />
      <label htmlFor='input-autocomplete-simply' className='dln-inputs__lbl'>
        {t('storeFinder:google.autocomplete.label')}
      </label>
      <button type='button' className='dln-inputs__button dln-outline'>
        <i className='dln-icn'>Q</i>
      </button>
    </div>
  );
};

GoogleAutocomplete.propTypes = {
  googleMapIsLoaded: PropTypes.bool.isRequired,
};

export default GoogleAutocomplete;
